import type {} from "@lit/react";
import { GridColumn as GridColumnElement, } from "@vaadin/grid/vaadin-grid-column.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { GridColumnElement, };
export type GridColumnEventMap = Readonly<{}>;
const events = {} as GridColumnEventMap;
export type GridColumnProps<T1> = WebComponentProps<GridColumnElement<T1>, GridColumnEventMap>;
export const GridColumn = createComponent({
    elementClass: GridColumnElement, events, react: React, tagName: "vaadin-grid-column"
}) as <T1>(props: GridColumnProps<T1> & React.RefAttributes<GridColumnElement<T1>>) => React.ReactElement | null;
